"use client";

import { SlidersHorizontal } from "lucide-react";
import { useTranslations } from "next-intl";
import { useCallback, useState, useTransition } from "react";

import { useRouter } from "@/i18n/navigation";
import { cn } from "@/lib/utils";

import { TagFilterChips } from "./TagFilterChips";
import { TagManageSheet } from "./TagManageSheet";

interface RecipeTagBarProps {
  initialTags: string[];
  selected: string[];
  query?: string;
}

export function RecipeTagBar({ initialTags, selected, query }: RecipeTagBarProps) {
  const t = useTranslations("recipes");
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const [tags, setTags] = useState(initialTags);
  const [, startTransition] = useTransition();

  const handleSave = useCallback(
    (newTags: string[]) => {
      fetch("/api/tags/filters", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tags: newTags }),
      }).catch(() => {});
      setTags(newTags);
      startTransition(() => {
        router.refresh();
      });
    },
    [router]
  );

  const manageButton = (
    <button
      type="button"
      onClick={() => setOpen(true)}
      aria-label={t("manageTags")}
      className={cn(
        "shrink-0 cursor-pointer rounded-full border border-input-border bg-input-bg p-2 text-foreground",
        "transition-colors hover:bg-secondary-dark"
      )}
    >
      <SlidersHorizontal className="size-3.5" aria-hidden />
    </button>
  );

  return (
    <>
      <TagFilterChips
        tags={tags}
        selected={selected}
        query={query}
        logSearches
        trailingContent={manageButton}
      />
      <TagManageSheet open={open} onOpenChange={setOpen} currentTags={tags} onSave={handleSave} />
    </>
  );
}
